@if (isRenewBenefits || isReportChange) {
<p>{{ "RENEWAL_TEXT" | globalTranslate }}</p>
}<br />
<nh-form
  class="demographics"
  [individuals]="individuals"
  [formGroup]="getForm()"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    @if (record && record.data && record.data.householdHead) {
    <div class="static-text">
      @if (this.isPresumptive) {
      <h1 class="static-text">
        Start with yourself, then add other people who live with you.
      </h1>
      } @if (!this.isPresumptive) {
      <h1 class="static-text">
        {{ "DEMOGRAPHICS_STATIC_TEXT_1" | globalTranslate }}
      </h1>
      }
      <p>
        <strong>{{ "DEMOGRAPHICS_STATIC_TEXT_2" | globalTranslate }}</strong>
      </p>
      <ul class="list-inline ps-1">
        <li>{{ "DEMOGRAPHICS_STATIC_TEXT_3_1" | globalTranslate }}</li>
        <li>{{ "DEMOGRAPHICS_STATIC_TEXT_3_2" | globalTranslate }}</li>
        <li>{{ "DEMOGRAPHICS_STATIC_TEXT_3_3" | globalTranslate }}</li>
        <li>{{ "DEMOGRAPHICS_STATIC_TEXT_3_4" | globalTranslate }}</li>
        <li>{{ "DEMOGRAPHICS_STATIC_TEXT_3_5" | globalTranslate }}</li>
      </ul>
      <br />
      <p>
        <strong>{{ "DEMOGRAPHICS_STATIC_TEXT_4" | globalTranslate }}</strong>
      </p>
      <ul class="list-inline ps-1">
        <li>{{ "DEMOGRAPHICS_STATIC_TEXT_5_1" | globalTranslate }}</li>
        <li>{{ "DEMOGRAPHICS_STATIC_TEXT_5_2" | globalTranslate }}</li>
      </ul>
      <br />
      <p>
        <strong>{{ "DEMOGRAPHICS_STATIC_TEXT_6" | globalTranslate }}</strong>
      </p>
      <ul class="list-inline ps-1">
        <li>{{ "DEMOGRAPHICS_STATIC_TEXT_7_1" | globalTranslate }}</li>
        <li>{{ "DEMOGRAPHICS_STATIC_TEXT_7_2" | globalTranslate }}</li>
        <li>{{ "DEMOGRAPHICS_STATIC_TEXT_7_3" | globalTranslate }}</li>
        <li>{{ "DEMOGRAPHICS_STATIC_TEXT_7_4" | globalTranslate }}</li>
      </ul>
      <br />
    </div>
    } @if (!isPresumptive) {
    <h2 class="person-label">
      @if (record && record.data && record.data.householdHead) {
      <span>{{ "HEAD_OF_HOUSEHOLD" | globalTranslate }}: </span>
      }
      {{ selectedIndividual | fullname }}
    </h2>
    } @if (isPresumptive) {
    <p>
      @if (record && record.data && record.data.householdHead) {
      <span><strong>People You've Told Us About</strong> </span>
      }
    </p>
    } @if (isPresumptive && !selectedIndividual?.age) {
    <h2 class="person-label">
      {{ selectedIndividual?.name?.firstName }}
      {{ selectedIndividual?.name?.lastName }}
    </h2>
    } @if (isPresumptive && selectedIndividual?.age) {
    <h2 class="person-label">
      {{ selectedIndividual?.name?.firstName }}
      {{ selectedIndividual?.name?.lastName }}, {{ selectedIndividual?.age }}
      {{ selectedIndividual?.gender?.code }}
    </h2>
    }
    <br />
    @if (isPresumptive) {
    <h2 class="section-header">Individual Information</h2>
    } @if (!isPresumptive) {
    <h2 class="section-header">
      {{ "LINK_CASE_DESC_PERSONAL" | globalTranslate }}
    </h2>
    }
    <hr />
    @if (isEnabled('data.name')) {
    <nh-name-address
      [addressname]="'de_name'"
      [personalName]="getControl('data.name')"
      [tables]="tables"
      [namePopup]="displayPopup()"
      [isDemographics]="true"
      [rmcPopUp]="displayRmcPopup()"
      [selectedIndividualPopup]="isIndividualPopup()"
      [isExported]="exported ? true : null"
    >
    </nh-name-address>
    } @if (isEnabled('data.name')) {
    <span><br /></span>
    } @if (isPresumptive) {
    <nh-field id="de_gender" label="Gender" class="label-section">
      <select
        aria-label="Gender"
        [attr.aria-required]="true"
        nhTranslate
        [name]="getControl('gender')"
        formControlName="gender"
        [items]="tables.GENDER"
      ></select>
    </nh-field>
    } @if (isPresumptive) {
    <nh-field id="de_birthDate" label="Date of Birth" class="label-section">
      <nh-datepicker>
        <input
          aria-label="Date of Birth"
          [attr.aria-required]="true"
          type="text"
          name="birthDate"
          class="form-control"
          (change)="isInvalidDate($event)"
          formControlName="birthDate"
          (bsValueChange)="isInvalidDate($event)"
          bsDatepicker
          nh
          [minDate]="minimumDate"
          [maxDate]="presumptiveDateOfApp"
          [attr.disabled]="exported ? true : null"
        />
      </nh-datepicker>
    </nh-field>
    } @if (!isPresumptive) {
    <div>
      <h2 class="section-header">{{ "ALTERNATE_NAME" | globalTranslate }}</h2>
      <hr />
      <nh-field
        id="de_appliedWithOtherName"
        label="{{ 'IS' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'OTHER_NAME' | globalTranslate }}"
        class="label-section"
      >
        <select
          [attr.aria-labelledby]="'de_appliedWithOtherName'"
          [attr.aria-required]="true"
          nhTranslate
          name="appliedWithOtherName"
          formControlName="appliedWithOtherName"
          [items]="tableCodeValue('YESNO', 'data.appliedWithOtherName')"
        ></select>
      </nh-field>
      @if (isEnabled('data.otherName')) {
      <nh-name-address
        [addressname]="'de_otherName'"
        [personalName]="getControl('data.otherName')"
        [tables]="tables"
      >
      </nh-name-address>
      }
    </div>
    } @if (isSameName && !isPresumptive) {
    <span class="form-text invalid-name d-block">
      {{ "ALTERNATE_INVALID_NAME" | globalTranslate }}</span
    >
    } @if (!isPresumptive) {
    <div>
      <br />
      <div>
        <h2 class="section-header">
          {{ "PERSONAL_DETAILS" | globalTranslate }}
        </h2>
        <hr />
      </div>
      <nh-field
        id="de_gender"
        label="{{ 'GENDER' | globalTranslate }}"
        class="label-section"
      >
        <select
          [attr.aria-label]="'GENDER' | globalTranslate"
          [attr.aria-required]="true"
          [attr.disabled]="exported ? true : null"
          nhTranslate
          name="gender"
          formControlName="gender"
          [items]="tableCodeValue('GENDER', 'data.gender')"
        ></select>
      </nh-field>
      <nh-field
        id="de_birthDate"
        label="{{ 'DOB' | globalTranslate }}"
        class="label-section"
      >
        @if (isRenewBenefits || isIndividualPopup()) {
        <nh-popover
          class="ps-1"
          content="{{ 'RMB_DOB_TEXT' | globalTranslate }}"
        ></nh-popover>
        }
        <nh-datepicker [readOnly]="exported ? true : false">
          <input
            [attr.aria-label]="'DOB' | globalTranslate"
            [attr.aria-required]="true"
            type="text"
            name="birthDate"
            class="form-control"
            (change)="isInvalidDate($event)"
            formControlName="birthDate"
            bsDatepicker
            nh
            [minDate]="minimumDate"
            [maxDate]="today"
            [attr.disabled]="exported ? true : null"
          />
        </nh-datepicker>
      </nh-field>
    </div>
    }
    <br />

    <h2 class="section-header">
      {{ "APPLYING_FOR_COVERAGE" | globalTranslate }}
    </h2>
    <hr />
    @if (isPresumptive) {
    <p class="static-text">
      Presumptive Eligibility is temporary health coverage and lasts no more
      than 90 days. If approved, this helps you start getting care right away.
      <br /><br />
      If you are approved for Presumptive Eligibility, you can also apply to
      keep TennCare past your temporary coverage. If you choose not to apply for
      temporary Presumptive Eligibility, you can still complete a TennCare
      application.
    </p>
    @if (isAppBCC) {
    <br />
        <div class="col message">
          <span>
            <b> Note: </b> Only one person can apply for Presumptive Breast/Cervical 
            Cancer coverage per application. If there is more than one person in your 
            household who needs to apply for Presumptive Eligibility, please submit a 
            separate application. All other household members may still apply for ongoing 
            TennCare coverage on this application.
          </span>
        </div>
        <nh-alert
        type="danger"
        [isOpen]="showBCCBlockingWarning"
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span>{{ "BCC_BANNER_IN_PEOPLE_SCREEN" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
    }
    }
    <br />
    @if (this.isPresumptive) {
    <nh-field
      id="de_applyForCoverage"
      label="Is {{
        selectedIndividual | fullname
      }} applying for Presumptive Coverage?"
      class="label-section"
    >
      <select
        [attr.aria-labelledby]="'de_applyForCoverage'"
        [attr.aria-required]="true"
        nhTranslate
        name="applyForCoverage"
        formControlName="applyForCoverage"
        [items]="tables.YESNO"
        (change)="onApplyFprCovSelected($event)"
      ></select>
    </nh-field>
    } @if (!this.isPresumptive) {
    <nh-field
      id="de_applyForCoverage"
      label="{{ 'IS_1' | globalTranslate }}{{
        selectedIndividual | fullname
      }} {{ 'APPLYING_FOR_COVERAGE_WITH_US' | globalTranslate }}"
      class="label-section"
    >
      <select
        [attr.aria-labelledby]="'de_applyForCoverage'"
        [attr.aria-required]="true"
        nhTranslate
        name="applyForCoverage"
        formControlName="applyForCoverage"
        [items]="tableCodeValue('YESNO', 'data.applyForCoverage')"
        (change)="onApplyFprCovSelected($event)"
        (click)="onApplyForCovClick()"
      ></select>
    </nh-field>
    } @if (this.isPresumptive) {
    <nh-field
      id="de_applyForOnGoingCoverage"
      label="Is {{
        selectedIndividual | fullname
      }} applying for ongoing coverage?"
      class="label-section"
    >
      <select
        [attr.aria-labelledby]="'de_applyForOnGoingCoverage'"
        [attr.aria-required]="true"
        nh
        name="applyForOnGoingCoverage"
        formControlName="applyForOnGoingCoverage"
        [items]="tableCodeValue('YESNO', 'data.applyForOnGoingCoverage')"
        (change)="onApplyFprCovOnGoSelected($event)"
      ></select>
    </nh-field>
    }@if (this.isPresumptive) {
    <br />
    } @if (isPresumptive) {
    <div formGroupName="ssnInformation">
      <div>
        <h2 class="section-header">
          {{ "SOCIAL_SECURITY_INFO" | globalTranslate }}
        </h2>
        <hr />
        @if (ssnCoverage) {
        <div>
          <p
            class="static-text"
            [innerHTML]="'SOCIAL_SECURITY_STATIC_TEXT' | globalTranslate"
          ></p>
          <br />
          <p>{{ "SSN_TEXT_BULLETPOINT_Header" | globalTranslate }}</p>
          <ul class="list-inline ps-1">
            <li>{{ "SSN_LIST_1" | globalTranslate }}</li>
            <li>{{ "SSN_LIST_2" | globalTranslate }}</li>
            <li>{{ "SSN_LIST_3" | globalTranslate }}</li>
            <li>{{ "SSN_LIST_4" | globalTranslate }}</li>
            <li>{{ "SSN_LIST_5" | globalTranslate }}</li>
          </ul>
          <br />
          <p class="static-text">
            {{ "SOCIAL_SECURITY_STATIC_TEXT5" | globalTranslate }}
          </p>
          <br /><br />
        </div>
        }
        <p class="static-text">
          {{ "SOCIAL_SECURITY_STATIC_TEXT2" | globalTranslate }}<br /><br />
          <!--add aria-labels below -->
          <nh-field
            id="de_ssn"
            [mandatory]="false"
            [attr.aria-required]="false"
            label="Social Security Number"
            class="label-section"
          >
            @if (this.isPresumptive) {
            <span>
              <nh-popover
                field-label
                class="ml-2 ps-1"
                [content]="presumptiveSsnPop"
              ></nh-popover>
            </span>
            } @if (!this.isPresumptive) {
            <span>
              <nh-popover
                field-label
                class="ml-2 ps-1"
                [content]="ssnPop | globalTranslate"
              ></nh-popover>
            </span>
            }
            <input
              type="text"
              aria-label="Social Security Number"
              name="ssn"
              formControlName="ssn"
              class="form-control"
              placeholder="XXX-XX-XXXX"
              mask="000-00-0000"
              (blur)="compareSSN()"
            />
          </nh-field>
        </p>
      </div>

      <div>
        <nh-field
          id="de_ssnConfirm"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'CONFIRM_SSN' | globalTranslate }}"
          class="label-section"
        >
          <input
            [attr.aria-label]="'CONFIRM_SSN' | globalTranslate"
            type="text"
            name="ssnConfirm"
            formControlName="ssnConfirm"
            class="form-control"
            placeholder="XXX-XX-XXXX"
            mask="000-00-0000"
            [attr.disabled]="exported ? true : null"
            (blur)="compareSSN()"
          />
        </nh-field>
      </div>
      <nh-alert
        type="warning"
        [isOpen]="
          getControl('data.ssnInformation.ssn').touched &&
          isEmpty('data.ssnInformation.ssn')
        "
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt="warning"
            />
          </div>
          <div class="col message">
            <span>
              {{ "SOCIAL_SECURITY_STATIC_TEXT4" | globalTranslate }}
            </span>
          </div>
        </div>
      </nh-alert>
      <br />
      @if (!getValue('data.ssnInformation.ssn')) {
      <nh-field
        id="de_ssnAppliedDate"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="If {{
          selectedIndividual | fullname
        }} has applied for an SSN but has not received it, what date did he or she apply?"
        class="label-section"
      >
        <nh-datepicker>
          <input
            type="text"
            name="ssnAppliedDate"
            class="form-control"
            [attr.aria-labelledby]="'de_ssnAppliedDate'"
            formControlName="ssnAppliedDate"
            bsDatepicker
            nh
            [minDate]="minimumDate"
            [maxDate]="today"
          />
        </nh-datepicker>
      </nh-field>
      }
    </div>
    }<br />

    @if (!isPresumptive) {
    <div formGroupName="ssnInformation">
      <h2 class="section-header">
        {{ "SOCIAL_SECURITY_INFO" | globalTranslate }}
      </h2>
      <hr />
      @if (ssnCoverage) {
      <div>
        <p
          class="static-text"
          [innerHTML]="'SOCIAL_SECURITY_STATIC_TEXT' | globalTranslate"
        ></p>
        <span><br /></span>
        <p>{{ "SSN_TEXT_BULLETPOINT_Header" | globalTranslate }}</p>
        <ul class="list-inline ps-1">
          <li>{{ "SSN_LIST_1" | globalTranslate }}</li>
          <li>{{ "SSN_LIST_2" | globalTranslate }}</li>
          <li>{{ "SSN_LIST_3" | globalTranslate }}</li>
          <li>{{ "SSN_LIST_4" | globalTranslate }}</li>
          <li>{{ "SSN_LIST_5" | globalTranslate }}</li>
        </ul>
        <br />
        <p class="static-text">
          {{ "SOCIAL_SECURITY_STATIC_TEXT5" | globalTranslate }}
        </p>
        <br /><br />
      </div>
      }
      <p class="static-text">
        {{ "SOCIAL_SECURITY_STATIC_TEXT2" | globalTranslate }}
      </p>
      <br /><br />
      <div>
        <nh-field
          id="de_ssn"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'SSN' | globalTranslate }}"
          class="label-section"
        >
          @if (this.isPresumptive) {
          <span>
            <nh-popover
              field-label
              class="ml-2 ps-1"
              [content]="presumptiveSsnPop"
            ></nh-popover>
          </span>
          } @if (!this.isPresumptive) {
          <span>
            <nh-popover
              field-label
              class="ml-2 ps-1"
              [content]="ssnPop | globalTranslate"
            ></nh-popover>
          </span>
          }
          <input
            [attr.aria-label]="'SSN' | globalTranslate"
            type="text"
            name="ssn"
            formControlName="ssn"
            class="form-control"
            placeholder="XXX-XX-XXXX"
            mask="000-00-0000"
            [attr.disabled]="exported ? true : null"
            (blur)="compareSSN()"
          />
        </nh-field>
      </div>
      <div>
        <nh-field
          id="de_ssnConfirm"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'CONFIRM_SSN' | globalTranslate }}"
          class="label-section"
        >
          <input
            [attr.aria-label]="'CONFIRM_SSN' | globalTranslate"
            type="text"
            name="ssnConfirm"
            formControlName="ssnConfirm"
            class="form-control"
            placeholder="XXX-XX-XXXX"
            mask="000-00-0000"
            [attr.disabled]="exported ? true : null"
            (blur)="compareSSN()"
          />
        </nh-field>
      </div>
      <nh-alert
        type="warning"
        [isOpen]="
          getControl('data.ssnInformation.ssn').touched &&
          isEmpty('data.ssnInformation.ssn')
        "
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt="warning"
            />
          </div>
          <div class="col message">
            <span>{{ "SSN_ENTER_MANDATORY" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>
      <br />
      @if (!getValue('data.ssnInformation.ssn')) {
      <nh-field
        id="de_ssnAppliedDate"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'IF' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'SOCIAL_SECURITY_STATIC_TEXT3' | globalTranslate }}"
        class="label-section"
      >
        <nh-datepicker>
          <input
            [attr.aria-labelledby]="'de_ssnAppliedDate'"
            type="text"
            name="ssnAppliedDate"
            class="form-control"
            formControlName="ssnAppliedDate"
            bsDatepicker
            nhTranslate
            [minDate]="minimumDate"
            [maxDate]="today"
          />
        </nh-datepicker>
      </nh-field>
      } @if (!getValue('data.ssnInformation.ssn')) {
      <span><br /></span>
      }
    </div>
    }
    @if (isPresumptiveHospital && isInfant) {
      <nh-field
        id="nein_facilityBirthSw"
        [mandatory]="true"
        [attr.aria-required]="true"
        label="{{ 'WAS' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'BORN_IN_FACILITY' | globalTranslate }}"
        class="label-section"
      >
        <select
          [attr.aria-labelledby]="'facilityBirthSw'"
          [attr.aria-required]="true"
          nhTranslate
          name="facilityBirthSw"
          formControlName="facilityBirthSw"
          [items]="tableCodeValue('YESNO', 'data.facilityBirthSw')"
        ></select>
      </nh-field>
    }
    @if (isY('data.applyForCoverage') || isY('data.applyForOnGoingCoverage'))
    {
    <div formGroupName="citizenship">
      <h2 class="section-header">{{ "CITIZENSHIP" | globalTranslate }}</h2>
      <hr />
      @if (isEnabled('data.citizenship.usCitizen')) {
      <nh-field
        id="de_usCitizen"
        label="{{ 'IS' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'CITIZENSHIP_ STATIC_TEXT1' | globalTranslate }}"
        class="label-section"
      >
        <select
          [attr.aria-labelledby]="'de_usCitizen'"
          [attr.aria-required]="true"
          nhTranslate
          name="usCitizen"
          formControlName="usCitizen"
          [items]="tableCodeValue('YESNO', 'data.citizenship.usCitizen')"
          (change)="onCitizenshipChange()"
        ></select>
      </nh-field>
      } @if (isEnabled('data.citizenship.derivedCitizen') &&
      isY('data.citizenship.usCitizen')) {
      <nh-field
        id="de_derivedCitizen"
        label="{{ 'IS_1' | globalTranslate }}{{
          selectedIndividual | fullname
        }} {{ 'CITIZENSHIP_ STATIC_TEXT2' | globalTranslate }}"
        class="label-section"
      >
        <div class="hint">
          {{ "CITIZENSHIP_ STATIC_TEXT3" | globalTranslate }}
        </div>
        <select
          [attr.aria-labelledby]="'de_derivedCitizen'"
          [attr.aria-required]="true"
          nhTranslate
          name="derivedCitizen"
          formControlName="derivedCitizen"
          [items]="tableCodeValue('YESNO', 'data.citizenship.derivedCitizen')"
          (change)="onDerivedCitizenChange()"
        ></select>
      </nh-field>
      }
      <div formGroupName="document">
        @if (isEnabled('data.citizenship.document.registrationNumber') &&
        isY('data.citizenship.derivedCitizen')) {
        <nh-field
          id="de_registrationNumber"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'ALIEN_NUMBER' | globalTranslate }}"
          class="label-section"
        >
          <div class="d-flex align-items-center alien-num">
            <span class="pl-2 pe-3 tab-section">A</span>
            <input
              type="text"
              name="registrationNumber"
              [attr.aria-label]="'ALIEN_NUMBER' | globalTranslate"
              class="form-control"
              formControlName="registrationNumber"
              placeholder="XXXXXXXXX"
              mask="999999999"
              (input)="onAlienNumberChange($event)"
              (keypress)="restrictSplChar($event)"
            />
          </div>
          @if (isInvalidAlienNumber) {
          <div class="form-text invalid-name d-block">
            {{ "INVALID_ALIEN_NUMBER" | globalTranslate }}
          </div>
          }
        </nh-field>
        } @if
        (isEnabled('data.citizenship.document.naturalizationCertificateNumber')
        && isY('data.citizenship.derivedCitizen')) {
        <nh-field
          id="de_naturalizationCertificateNumber"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'NATURALIZATION_NUMBER' | globalTranslate }}"
          class="label-section"
        >
          <input
            [attr.aria-label]="'NATURALIZATION_NUMBER' | globalTranslate"
            type="text"
            name="naturalizationCertificateNumber"
            class="form-control"
            formControlName="naturalizationCertificateNumber"
            maxlength="12"
          />
        </nh-field>
        } @if
        (isEnabled('data.citizenship.document.naturalizationCertificateNumber')
        && isY('data.citizenship.derivedCitizen')) {
        <span><br /></span>
        }
      </div>
    </div>
    }

    <div formGroupName="livingArrangement">
      @if (isY('data.applyForCoverage') || isY('data.applyForOnGoingCoverage'))
      {
      <div>
        <h2 class="section-header">
          {{ "LIVING_ARRANGEMENT" | globalTranslate }}
        </h2>
        <hr />
      </div>
      } @if (isY('data.applyForCoverage') ||
      isY('data.applyForOnGoingCoverage')) {
      <nh-field
        id="de_livingAreaType"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'LIVING_ARRANGEMENT_STATIC_TEXT' | globalTranslate }}"
        class="label-section"
      >
        <nh-popover
          field-label
          class="ml-2 ps-1"
          [content]="livingArrangement | globalTranslate"
        ></nh-popover>
        <select
          [attr.aria-label]="'LIVING_ARRANGEMENT_STATIC_TEXT' | globalTranslate"
          nhTranslate
          name="livingAreaType"
          formControlName="livingAreaType"
          [items]="
            tableCodeValue(
              'LIVINGARRANGEMENTYPE',
              'data.livingArrangement.livingAreaType'
            )
          "
        ></select>
      </nh-field>
      } @if (isEnabled('data.livingArrangement.tennesseeResident') &&
      (isY('data.applyForCoverage') || isY('data.applyForOnGoingCoverage'))) {
      <nh-field
        id="de_tennesseeResident"
        label="{{ 'IS_1' | globalTranslate }}{{
          selectedIndividual | fullname
        }} {{ 'TENNESSEE_RESIDENT' | globalTranslate }}"
        class="label-section"
      >
        <nh-popover
          field-label
          class="ml-2 ps-1"
          [content]="residencyArrangement | globalTranslate"
        ></nh-popover>
        <select
          [attr.aria-labelledby]="'de_tennesseeResident'"
          [attr.aria-required]="true"
          nhTranslate
          name="tennesseeResident"
          formControlName="tennesseeResident"
          [items]="
            tableCodeValue('YESNO', 'data.livingArrangement.tennesseeResident')
          "
          (change)="onTennesseeResidentChange()"
        ></select>
      </nh-field>
      }

      <nh-alert type="warning" [isOpen]="showTennesseeResidentAlert">
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt="warning"
            />
          </div>
          <div class="col message">
            <span
              [innerHTML]="'TENNESSEE_RESIDENT_ALERT' | globalTranslate"
            ></span>
          </div>
        </div>
      </nh-alert>
      <br />

      @if (isEnabled('data.livingArrangement.outOfHome') &&
      (isY('data.applyForCoverage') || isY('data.applyForOnGoingCoverage'))) {
      <nh-field
        id="de_outOfHome"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'IS_3' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'OUT_OF_STATE' | globalTranslate }}"
        class="label-section"
      >
        <select
          [attr.aria-labelledby]="'de_outOfHome'"
          nhTranslate
          name="outOfHome"
          formControlName="outOfHome"
          [items]="tableCodeValue('YESNO', 'data.livingArrangement.outOfHome')"
          (change)="onTennesseeNonResidentChange()"
        ></select>
      </nh-field>
      } @if (isEnabled('data.livingArrangement.intendToReturn') &&
      (isY('data.applyForCoverage') || isY('data.applyForOnGoingCoverage'))) {
      <nh-field
        id="de_intendToReturn"
        [mandatory]="true"
        [attr.aria-required]="true"
        label="{{ 'DOES_1' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'PLAN_TO_RETURN' | globalTranslate }}"
        class="label-section"
      >
        <select
          [attr.aria-labelledby]="'de_intendToReturn'"
          [attr.aria-required]="true"
          nhTranslate
          name="intendToReturn"
          formControlName="intendToReturn"
          [items]="
            tableCodeValue('YESNO', 'data.livingArrangement.intendToReturn')
          "
          (change)="onTennesseeNonResidentChange()"
        ></select>
      </nh-field>
      }
      <nh-alert type="warning" [isOpen]="showTennesseeNonResidentAlert">
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt="warning"
            />
          </div>
          <div class="col message">
            <span
              [innerHTML]="'TENNESSEE_NON_RESIDENT_ALERT' | globalTranslate"
            ></span>
          </div>
        </div>
      </nh-alert>

      @if (isEnabled('data.livingArrangement.intendToReturnDate') &&
      (isY('data.applyForCoverage') || isY('data.applyForOnGoingCoverage'))) {
      <nh-field
        id="de_intendToReturnDate"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'DATE' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'PLANS_TO_RETURN' | globalTranslate }}"
        class="label-section"
      >
        <nh-datepicker>
          <input
            [attr.aria-labelledby]="'de_intendToReturnDate'"
            type="text"
            name="intendToReturnDate"
            class="form-control"
            formControlName="intendToReturnDate"
            [minDate]="minDate"
            (bsValueChange)="onReturnDateChange($event)"
            (change)="onReturnDateChange($event)"
            (focusout)="onFocusOutExpDate($event)"
            bsDatepicker
            nh
          />
        </nh-datepicker>
        @if (isInvalidExpDate) {
        <div class="form-text invalid-name d-block">
          {{ "INVALID_MAX_DATE" | globalTranslate }}
        </div>
        }
      </nh-field>
      }
    </div>

    @if (!isPresumptive) {
    <span><br /></span>
    }
    <table class="race-text">
      <tr>
        <th><span class="text-danger ng-star-inserted">*</span></th>
        <th>
          <h2 class="section-header">{{ "RACE" | globalTranslate }}</h2>
        </th>
      </tr>
    </table>
    <hr />
    @if (!isPresumptive) {
    <p class="static-text">
      {{ "TENNESSEE_RESIDENT_STATIC_TEXT1" | globalTranslate }}
    </p>
    } @if (!isPresumptive) {
    <span><br /></span>
    }
    <nh-alert type="warning" [isOpen]="raceWarning">
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
            alt="warning"
          />
        </div>
        <div class="col message">
          <span> {{ "RACE_STATIC_TEXT1" | globalTranslate }} </span>
        </div>
      </div>
    </nh-alert>
    <demographics-checkbox-list
      [selectedCodes]="selectedCodes"
      [selectedCode]="selectedCode"
      [isNASelected]="isNACodeSelected"
      [isUNSelected]="isUNCodeSelected"
      (valueChange)="selectDisabledValues($event)"
      [checkboxGroup]="this.getControl('extras.helpers.races')"
      [referenceTable]="tables.RACEDISPLAY"
    >
    </demographics-checkbox-list>
    <br />
    @if (isY('data.applyForCoverage') && !this.isPresumptive) {
    <div>
      <nh-field
        id="de_federalRecogizedTribe"
        [mandatory]="true"
        [attr.aria-required]="true"
        label="{{ 'IS' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'FEDRALLY_RECOGNIZED' | globalTranslate }}"
        class="label-section"
      >
        <select
          [attr.aria-labelledby]="'de_federalRecogizedTribe'"
          [attr.aria-required]="true"
          nhTranslate
          name="federalRecogizedTribe"
          formControlName="federalRecogizedTribe"
          [items]="tableCodeValue('YESNO', 'data.federalRecogizedTribe')"
        ></select>
      </nh-field>
    </div>
    } @if (isEnabled('data.tribeName')) {
    <nh-field
      id="de_tribeName"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'NAME_OF_TRIBE' | globalTranslate }}"
      class="label-section"
    >
      <input
        [attr.aria-label]="'NAME_OF_TRIBE' | globalTranslate"
        type="text"
        name="tribeName"
        formControlName="tribeName"
        class="form-control"
        maxlength="256"
      />
    </nh-field>
    } @if (isEnabled('data.healthProgram')) {
    <nh-field
      id="de_healthProgram"
      label="{{ 'HAS' | globalTranslate }} {{
        selectedIndividual | fullname
      }} {{ 'SERVICE' | globalTranslate }}"
      class="label-section"
    >
      <select
        [attr.aria-labelledby]="'de_healthProgram'"
        [attr.aria-required]="true"
        nhTranslate
        name="healthProgram"
        formControlName="healthProgram"
        [items]="tableCodeValue('YESNO', 'data.healthProgram')"
      ></select>
    </nh-field>
    } @if (isEnabled('data.eligHlthProgram')) {
    <nh-field
      id="de_eligHlthProgram"
      label="{{ 'IS_1' | globalTranslate }}{{
        selectedIndividual | fullname
      }} {{ 'INDIAN_HEALTH_SERVICE' | globalTranslate }}"
      class="label-section"
    >
      <select
        [attr.aria-labelledby]="'de_eligHlthProgram'"
        [attr.aria-required]="true"
        nhTranslate
        name="eligHlthProgram"
        formControlName="eligHlthProgram"
        [items]="tableCodeValue('YESNO', 'data.eligHlthProgram')"
      ></select>
    </nh-field>
    } @if (isEnabled('data.eligHlthProgram')) {
    <span><br /></span>
    }
    <h2 class="section-header">{{ "ETHNICITY" | globalTranslate }}</h2>
    <hr />
    <nh-field
      id="de_hispanicOrigin"
      [mandatory]="true"
      [attr.aria-required]="true"
      label="{{ 'ETHNICITY_STATIC_TEXT_1' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'ETHNICITY_STATIC_TEXT_2' | globalTranslate }}"
      class="label-section"
    >
      <div class="hint">{{ "ETHNICITY_STATIC_TEXT_3" | globalTranslate }}</div>
      <select
        [attr.aria-labelledby]="'de_hispanicOrigin'"
        [attr.aria-required]="true"
        nhTranslate
        name="hispanicOrigin"
        formControlName="hispanicOrigin"
        [items]="tableCodeValue('ETHNICITY', 'data.hispanicOrigin')"
      ></select>
    </nh-field>
  </section>
</nh-form>